import { render, staticRenderFns } from "./PlatformCamera.vue?vue&type=template&id=9b81d3ca"
import script from "./PlatformCamera.vue?vue&type=script&lang=js"
export * from "./PlatformCamera.vue?vue&type=script&lang=js"
import style0 from "./PlatformCamera.vue?vue&type=style&index=0&id=9b81d3ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports